import { render, staticRenderFns } from "./Demos.vue?vue&type=template&id=3293e121&scoped=true&lang=pug"
import script from "./Demos.vue?vue&type=script&lang=js"
export * from "./Demos.vue?vue&type=script&lang=js"
import style0 from "./Demos.vue?vue&type=style&index=0&id=3293e121&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3293e121",
  null
  
)

export default component.exports